






























import { Vue, Component } from "vue-property-decorator";
import { ORBA_ONE_CANCEL } from "@/modules/shared/constants.ts";
import { namespace } from "vuex-class";

const Home = namespace("home");

@Component({})
export default class PromptCancellation extends Vue {
  @Home.Action("promptForCancel") promptForCancel!: (
    isCancelling: boolean
  ) => void;
  @Home.Getter("getShouldPromptCancellation") shouldPromptCancellation;
  abortCancellation() {
    this.promptForCancel(false);
  }
  confirmCancellation() {
    this.closeFromParent();
  }
  closeFromParent() {
    // Check if verify was instantiated by another website or not
    if (window.self !== window.top) {
      const parent = window.top;
      parent.postMessage(ORBA_ONE_CANCEL, "*");
    } else {
      // Navigate to cancelled verification page
      this.promptForCancel(false);

      this.$router.push({
        name: "verification-cancelled",
      });
    }
  }
}
